export default "__VITE_ASSET__nRjYksSD__"